import React from 'react';
import { RESPONSE_OPTIONS } from '../../data/questions';
import type { AnswerValue, Question } from '../../types/assessment';
type QuestionBlockProps = {
  question: Question;
  index: number;
  total: number;
  value: AnswerValue | undefined;
  onChange: (value: AnswerValue) => void;
};
export function QuestionBlock({
  question,
  index,
  total,
  value,
  onChange
}: QuestionBlockProps) {
  const answered = value !== undefined;
  const groupId = `question-${question.id}`;
  return <fieldset className={`rounded-xl border bg-cream-light p-5 transition-colors duration-150 ease-out sm:p-6 ${answered ? 'border-harbor-light' : 'border-border'}`} data-id="element-26" data-mp="3lyuuh3q692jm">
      <legend className="sr-only" data-id="element-27" data-mp="3c91hpzeamhds">{question.text}</legend>
      <span className="block text-[11px] uppercase tracking-[0.08em] text-ink-muted" data-id="element-28" data-mp="3c9l17kjlddtx">
        {index} of {total}
      </span>
      <p id={groupId} className="mt-1.5 text-[15px] leading-relaxed text-ink sm:text-base" data-id="element-29" data-mp="2ybd7dlhuqsmz">
        {question.text}
      </p>

      <div className="mt-4 grid grid-cols-2 gap-1.5 sm:grid-cols-5" role="group" aria-labelledby={groupId} data-id="element-30" data-mp="1pw8u3ukywa0l">
        {RESPONSE_OPTIONS.map((label, optionIndex) => {
        const selected = value === optionIndex;
        return <button key={label} type="button" aria-pressed={selected} onClick={() => onChange(optionIndex as AnswerValue)} className={`rounded-md border px-2 py-2.5 text-center text-[12px] leading-tight transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-1 focus-visible:ring-offset-cream-light ${selected ? 'border-teal bg-teal font-medium text-cream-light' : 'border-border bg-cream text-ink-light hover:border-harbor-light hover:bg-harbor-pale'} ${optionIndex === 4 ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-31" data-mp="1yvvwailitjup" data-mpi={optionIndex}>
              {label}
            </button>;
      })}
      </div>
    </fieldset>;
}